module.exports = __webpack_public_path__ + "img/profile-img.ed389b40.svg";